module.exports = __webpack_public_path__ + "static/media/tip-inactive.1ca043c1.svg";